import { createClient } from '@libsql/client';

const db = createClient({
  url: import.meta.env.VITE_TURSO_DB_URL,
  authToken: import.meta.env.VITE_TURSO_AUTH_TOKEN
});

const DEFAULT_FOOTER_CONTENT = {
  lastUpdated: new Date().toISOString(),
  brandName: "Antacres",
  brandDescription: "Your trusted partner in real estate, helping you discover your perfect place to live in India.",
  socialIcons: [
    { platform: "facebook", url: "https://facebook.com" },
    { platform: "twitter", url: "https://twitter.com" },
    { platform: "instagram", url: "https://instagram.com" },
    { platform: "linkedin", url: "https://linkedin.com" }
  ],
  contactInfo: [
    { type: "phone", text: "+91 984 882 2522", link: "tel:+919848822522", icon: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" },
    { type: "email", text: "reachus@antacres.com", link: "mailto:reachus@antacres.com", icon: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" },
    { type: "location", text: "Hyderabad, Telangana, India", icon: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0zM15 11a3 3 0 11-6 0 3 3 0 016 0z" }
  ],
  quickLinks: [
    { title: "Properties", link: "/properties" },
    { title: "About Us", link: "/about" },
    { title: "Contact", link: "/contact" },
  ],
  bottomLinks: [
    { title: "Privacy", link: "/privacy" },
    { title: "Terms", link: "/terms" }
  ],
  copyrightText: `© ${new Date().getFullYear()} Antacres. All rights reserved.`
};

async function ensureTableExists() {
  try {
    await db.execute(`
      CREATE TABLE IF NOT EXISTS footer_content (
        id TEXT PRIMARY KEY,
        content_data TEXT NOT NULL,
        updated_at TEXT NOT NULL
      );
    `);
  } catch (error) {
    console.error("Error creating footer_content table:", error);
    throw new Error('Could not create footer_content table in database.');
  }
}

async function getFooterContent() {
  await ensureTableExists();
  try {
    const result = await db.execute({
      sql: `SELECT content_data, updated_at FROM footer_content WHERE id = ?`,
      args: ['footer-content'],
    });

    if (result.rows.length > 0) {
      const content = JSON.parse(result.rows[0].content_data);
      content.lastUpdated = result.rows[0].updated_at;
      return content;
    } else {
      console.log('No content found for Footer, returning default and saving it.');
      await createOrUpdateFooterContent(DEFAULT_FOOTER_CONTENT);
      return DEFAULT_FOOTER_CONTENT;
    }
  } catch (error) {
    console.error("Error fetching Footer content:", error);
    throw new Error('Could not fetch Footer content from database.');
  }
}

// Create or update content
async function createOrUpdateFooterContent(content) {
  await ensureTableExists();
  const now = new Date().toISOString();
  try {
    const serializedContent = JSON.stringify({ ...content, lastUpdated: now });
    await db.execute({
      sql: `
        INSERT INTO footer_content (id, content_data, updated_at) VALUES (?, ?, ?)
        ON CONFLICT(id) DO UPDATE SET content_data = ?, updated_at = ?;
      `,
      args: [
        'footer-content',
        serializedContent,
        now,
        serializedContent,
        now
      ],
    });
    console.log('Footer content created or updated successfully!');
    return JSON.parse(serializedContent);
  } catch (error) {
    console.error("Error creating or updating Footer content:", error);
    throw new Error('Could not save Footer content to database.');
  }
}

export const footerService = {
  getFooterContent,
  createOrUpdateFooterContent
};
